// extracted by mini-css-extract-plugin
export default {"heading":"Section_heading__Tlf8y","divider":"Section_divider__jOek5","body":"Section_body__L8r+6"};